/* jshint esversion: 6 */
import React from 'react';
import DropDownModule from 'app/mixins/DropDownModule.js';
import * as IconFactory from 'app/components/common/IconFactory.jsx';
import classnames from 'classnames';

class GenericItem extends React.Component {

	render() {
		let itemClass = classnames('sort-item',
			{
				'active-item': this.props.itemActive
			}
		);


		return (
			<li key={this.props.key} className="sort-item" onClick={this.props.onClick}>
				<div className="filter-label">
					{this.props.item.name}
				</div>
			</li>
		);

	}

};

export default DropDownModule(GenericItem);
